import React, { useState } from 'react';

//@Packages
import { useTranslation } from 'react-i18next';
import { Button, Control, Input, Label, Modal } from '@forge/common';

//@Utils
import { LOCALE_CONST } from '../../../utils/constants';

//@Styles
import './ConnectModal.scss';

interface AddRemoveDeviceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (data: { localPort: string; portUsage: string }) => void;
  title: string;
  content: string;
  footerLeftButtonText?: string;
  footerRightButtonText?: string;
  confirmButtonVariant?: any;
}

const AddDevicePortModal: React.FC<AddRemoveDeviceModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  content,
  footerLeftButtonText,
  footerRightButtonText,
  confirmButtonVariant,
}) => {
  const { t } = useTranslation();

  // State to manage input values
  const [localPort, setLocalPort] = useState<string>('');
  const [portUsage, setPortUsage] = useState<string>('');

  const handleConfirm = () => {
    onConfirm({ localPort, portUsage });
    setLocalPort('');
    setPortUsage('');
  };

  const handleCancel = () => {
    setLocalPort('');
    setPortUsage('');
    onClose();
  };

  return (
    <>
      {isOpen && (
        <Modal
          backdrop
          title={title}
          onBackdropClick={handleCancel}
          onModalClose={handleCancel}
          className="add-port-confirmation-modal"
        >
          <div className="confirmation-modal-content">
            <p className="pb-5">{content}</p>
            <Control>
              <Label required>{t(LOCALE_CONST.localPort)}</Label>
              <Input
                size="regular"
                type="text"
                placeholder={t(LOCALE_CONST.enterPort)}
                id="localPort"
                value={localPort}
                onChange={(e) => setLocalPort(e.target.value)}
              />
            </Control>
            <Control>
              <Label required>{t(LOCALE_CONST.portUsage)}</Label>
              <Input
                size="regular"
                type="text"
                placeholder={t(LOCALE_CONST.enterPortUsage)}
                id="portUsage"
                value={portUsage}
                onChange={(e) => setPortUsage(e.target.value)}
              />
            </Control>
          </div>
          <div className="confirmation-modal-footer">
            <Button onClick={handleCancel} variant="secondary">
              {footerLeftButtonText || t(LOCALE_CONST.cancel)}
            </Button>
            <Button
              onClick={handleConfirm}
              variant={confirmButtonVariant || 'primary'}
            >
              {footerRightButtonText || t(LOCALE_CONST.confirm)}
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AddDevicePortModal;